import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivityInterface } from '@sport-activities/sdk';
import { Subscription } from 'rxjs';
import { appConfig } from '~/app.config';

import { PaginationTypeEnum } from '~/attendee/components/shared/pagination/enums/pagination-type.enum';
import { getActivityDetailRouteName } from '~/attendee/helpers/activity/activity-detail-route-name.helper';
import { getDefaultFilter } from '~/attendee/helpers/activity/default-filter-params.helper';
import { PaginatedSearchService } from '~/attendee/service/paginated-search.service';
import { TipsVariantEnum } from '~/component/tips/enum/variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { Activity } from '~/core/model/activity.model';
import { OrganizationService } from '~/core/services/organization/organization.service';
import { TagManagerService } from '~/core/services/tag-manager/tag-manager.service';
import { TitleService } from '~/core/services/title/title.service';
import { ViewportScroller } from '@angular/common';
import { ActivityFilterParamsInterface } from '~/attendee/interfaces/activity-filter-params.interface';
import { deepMerge } from '~/core/helpers/object/deep-merge/deep-merge.helper';

@Component({
  selector: 'app-attendee-organizer-activities',
  templateUrl: './organizer-activities.component.html',
  styleUrls: ['./organizer-activities.component.scss'],
})
export class AttendeeOrganizerActivitiesComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  private activitiesFilter: ActivityFilterParamsInterface;

  public readonly iconTypeEnum = VtmnPlayIconTypeEnum;
  public readonly paginationType = PaginationTypeEnum;
  public readonly tipsVariant = TipsVariantEnum;

  public displayArrowIcon = false;
  public hasLoadMoreButton = false;
  public items: ActivityInterface[] = [];
  public p = 1;
  public itemsPerPage = appConfig?.pagination?.result;
  public total: number;

  constructor(
    @Inject('ActivitySearchService')
    private readonly searchService: PaginatedSearchService<
      Activity,
      ActivityFilterParamsInterface
    >,
    private readonly titleService: TitleService,
    private readonly tagManager: TagManagerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly organizationService: OrganizationService,
    private readonly viewportScroller: ViewportScroller
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.activitiesFilter = deepMerge<ActivityFilterParamsInterface>(
      getDefaultFilter(false),
      {
        includeNextDates: true,
      }
    );

    this.subscriptions.add(
      this.activatedRoute.parent?.data.subscribe(({ data }) => {
        this.activitiesFilter.organizationIdentifier = data.identifier;
      })
    );

    this.subscriptions.add(
      this.organizationService
        .getOrganizationById(this.activitiesFilter?.organizationIdentifier)
        .subscribe({
          next: (organizer) => {
            this.titleService.setPageTitle('seo.organizer.activities.title', {
              organizerName: organizer?.name,
            });
          },
        })
    );

    this.searchService.search(this.activitiesFilter).subscribe((results) => {
      this.items = [];
      this.total = results.total;
      this.items = this.items?.concat(results?.items);

      if (results.total === 0) {
        this.tagManager.pushNoResult('Activités');
      }
    });
  }

  public changePage($event): void {
    this.p = $event;
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  public getPath(activity: ActivityInterface): string {
    return getActivityDetailRouteName(activity.type, activity.sku);
  }
}
